module.exports = __webpack_public_path__ + "img/code.22824cb0.png";